import { ArrowRight, Plus } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

function Banner({ item }) {
  
  return (
   <div className="custom-banner-wrapper">
   {/* IMAGE */}
          <img
            src={item?.image}
            alt={item?.title || "Banner"}
            loading="lazy"
            className="custom-banner-img"
          />

          {/* OVERLAY */}
          {item?.title && (
            <div className="custom-banner-overlay">
              {item?.title && (
                <h2 className="custom-banner-title">{item.title}</h2>
              )}

              {item?.subtitle && (
                <p className="custom-banner-subtitle">{item.subtitle}</p>
              )}

              <Link to="/shop" className="spotlight-btn-hero">
                <span>Discover More</span>
                <ArrowRight size={16} className="spotlight-btn-icon-hero" />
              </Link>
            </div>
          )}</div>
  );
}

export default Banner;